import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { InternalServerError, LabelText,  } from 'shared/components';

export const BrokenLayout = () => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        margin: 32px 0;
      `}
    >
      <InternalServerError />
    </div>
  );
};

export const OverviewContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 8px;
  background-color: ${({ theme }) => theme.backgroundColor};
  font-family: ${({ theme }) => theme.fontFamily};
  
  form {
    max-width: 600px;
    
    h2 {
      color: ${({ theme }) => theme.primaryColor};
      font-weight: 600;
      font-size: 20px;
      line-height: 26px;
    }
    
    > ${LabelText} {
      margin-top: 16px;
    }
  }
`;
